/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { Box, Button, Divider, Grid, IconButton, Typography } from '@material-ui/core'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { X } from 'react-feather'
import { useTranslation } from 'react-i18next'

import { StyleVariables } from '../../../../../assets/js/StyleSheetVariables'
import { noop } from '../../../../../helpers/utils'
import CustomDialog from '../../../../common/CustomDialog'

/**
 * Defines a component Confirm Box
 * @param props
 * @returns {*}
 * @constructor
 */
function SchoolStoreAddOn({
  open,
  close,
  paymentGateways,
  selectedGateway,
  onGatewaySelect,
  onSchoolAddOn,
  wallet,
  totalAmount,
  selectedStoresList,
}) {
  const { t } = useTranslation()

  const onSubmit = () => {
    onSchoolAddOn()
  }

  /**
   * Render JSX of  confirm Box modal
   */

  return (
    <CustomDialog
      paper="true"
      className="custom-dialog"
      close={close}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="sm"
    >
      <>
        <DialogTitle disableTypography id="customized-dialog-title">
          <Box pt={1} display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h5" tabIndex={0}>
              <Box component="span" fontWeight="fontWeightBold">
                {t('selectPaymentMethod')}
              </Box>
            </Typography>
            <IconButton aria-label="close" className="close-button" onClick={close} tabIndex={-1}>
              <X />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent tabIndex={0}>
          <Box
            display="flex"
            alignItems="flex-start"
            justifyContent="flex-start"
            flexDirection="column"
            mb={3}
          >
            <Typography variant="body1" tabIndex={0}>
              <Box
                component="span"
                fontSize="12px"
                fontWeight={500}
                color={StyleVariables.primaryBlack}
              >
                {t(
                  'Select the Payment method and click on Pay Now to proceed to the checkout page.'
                )}
              </Box>
            </Typography>
          </Box>
          <Box mb={1}>
            {selectedStoresList?.map((row) => {
              return (
                <Grid container spacing={2} display="flex" alignItems="center" key={row.afc_id}>
                  <Grid item xs={12} sm={4}>
                    <Typography variant="body1" tabIndex={0}>
                      <Box
                        component="span"
                        fontWeight="fontWeightMedium"
                        fontSize="14px"
                        color={StyleVariables.primaryBlack}
                      >
                        {row?.afc_fee_name}
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={7}>
                    <Typography variant="body1" tabIndex={0}>
                      <Box component="span">
                        <Box component="span" className="manualMakePeding">
                          {t('with$', { amount: row.afc_amount })}
                        </Box>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              )
            })}
          </Box>
          <Divider />
          <Box mt={0.5}>
            <Grid container spacing={2} display="flex" alignItems="center">
              <Grid item xs={12} sm={4}>
                <Typography variant="body1" tabIndex={0}>
                  <Box
                    component="span"
                    fontWeight="fontWeightMedium"
                    fontSize="14px"
                    color={StyleVariables.primaryBlack}
                  >
                    {t('totalAmount')}
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={7}>
                <Typography variant="body1" tabIndex={0}>
                  <Box component="span">
                    <Box component="span" className="manualMakePeding">
                      {t('with$', { amount: totalAmount })}
                    </Box>
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            pt={2}
            pb={2}
            className="makePayment-wrapper"
          >
            {paymentGateways.map((gateway) => {
              const walletDisabled =
                gateway.gateway_master_alias === 'wallet' && wallet.points_balance === '0'
              return (
                <Box
                  key={`gateway_key_${gateway.id}`}
                  px={2}
                  py={1}
                  mr={{ xs: 0, sm: 2 }}
                  mt={{ xs: 2, sm: 1 }}
                  data-id={gateway.id}
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  flexDirection="row"
                  disabled={walletDisabled}
                  onClick={!walletDisabled ? onGatewaySelect : noop}
                  className={clsx({
                    'pay-method': true,
                    selected: gateway.id.toString() === selectedGateway.toString(),
                  })}
                >
                  <Box className="pay-radio-icon">
                    <Box className="selected-radio"></Box>
                  </Box>
                  <Box
                    pl={1.5}
                    display="flex"
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    flexDirection="column"
                    width="calc(100% - 25px)"
                  >
                    <Box
                      display="flex"
                      alignItems="flex-start"
                      justifyContent="flex-start"
                      flexDirection="row"
                      flexWrap="wrap"
                    >
                      <Box maxWidth="lg">
                        <img src={gateway.image} alt={gateway.name} />
                      </Box>

                      {gateway.gateway_master_alias === 'wallet' && (
                        <Box fontSize={14} fontWeight={600} width="100%">
                          {`(${wallet.points_balance || 0} Points)`}
                        </Box>
                      )}
                      {walletDisabled && (
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          className="text-secondary"
                          fontSize={14}
                          fontWeight={600}
                        >
                          {t('lowBalance')}
                        </Box>
                      )}
                    </Box>

                    <Box
                      className="color-blue-grey4"
                      mt={1}
                      component="div"
                      fontWeight="500"
                      fontSize="12px"
                    >
                      {gateway.alias}
                    </Box>
                  </Box>
                </Box>
              )
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            className="custom-default-button text-transform-none"
            onClick={close}
            size="large"
            variant="contained"
            disableElevation
          >
            {t('cancel')}
          </Button>
          <Button
            autoFocus
            color="primary"
            variant="contained"
            size="large"
            disableElevation
            className="text-transform-none"
            onClick={onSubmit}
            disabled={!selectedGateway}
          >
            {t('payNow')}
          </Button>
        </DialogActions>
      </>
    </CustomDialog>
  )
}

SchoolStoreAddOn.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  paymentGateways: PropTypes.array,
  selectedGateway: PropTypes.string,
  onGatewaySelect: PropTypes.func,
  onSchoolAddOn: PropTypes.func,
  wallet: PropTypes.object,
  additionalFeeDetail: PropTypes.object,
  totalAmount: PropTypes.number,
  selectedStoresList: PropTypes.array,
}
SchoolStoreAddOn.defaultProps = {
  open: false,
  close: noop,
  paymentGateways: [],
  selectedGateway: '',
  onGatewaySelect: noop,
  onSchoolAddOn: noop,
  wallet: {},
  additionalFeeDetail: {},
  totalAmount: 0,
  selectedStoresList: [],
}

/**
 /**
 * Confirm Box modal component
 */

export default SchoolStoreAddOn
